//import { useSelector } from "react-redux"; //Vishy 2025-18-02 build warning - not used
import { api } from "./config/axiosConfig.js";
import { defineCancelApiObject } from "./config/axiosUtils.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

export const BuyerAPI = {
  /////////////////////////
  // EVENTS
  ////////////////////////

  getEvents: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/buyers/events",
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: events derived from BuyerSellerMapping for this buyer's seller list 20-03-2026
  getSellerListEvents: async () => {
    const { token } = await store.getState().user;
    try {
      const response = await api.request({
        url: "/buyers/sellers/events",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: changed from path param to query param for optional event filter 18-02-2026
  getBuyerCompanies: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/browse",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: Fetch tradeshows a seller has participated in — shown in expanded card and profile drawer 24-02-2026
  getSellerEvents: async (sellerId, cancel = false) => {
    const { token } = await store.getState().user;
    try {
      const response = await api.request({
        url: `/sellers/${sellerId}/events`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  getSellers: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/seller/companies",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getBuyerProfile: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  updateBuyerProfile: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers",
      method: "PUT",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Send OTP for phone verification
  sendOTP: async (phoneNumber, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/send-otp",
      method: "POST",
      data: { phoneNumber },
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[BuyerAPI.sendOTP.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Verify OTP for phone verification
  verifyOTP: async (phoneNumber, otp, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/verify-otp",
      method: "POST",
      data: { phoneNumber, otp },
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[BuyerAPI.verifyOTP.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  PostRelevanceSeller: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "pre-qualify/seller",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },
  GetDashboard: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/dashboard",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },
  getInterestedTags: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/interested-tags",
      params,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },
  getRewardsByBuyerId: async (params, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `rewards/rewardStatements`,
      params,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },
  getRedemptionsSummary: async (params, cancel = false) => { //Vishy 2025-02-23 renamed from getRewardsRedemption
    const { token } = await store.getState().user;
    console.log('Params being sent:',params);
    const response = await api.request({
      url: `/redemptions/redemptions-summary`,
      params,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    console.log("BuyerAPI Response for Redemption Summary",response)
    return response.data;
  },

  getRedemptions: async (params, cancel = false) => {
    const { token } = await store.getState().user;
    console.log("Fetching redemptions with params:", params);
  
    const response = await api.request({
      url: `/redemptions/redemption`,
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
  
    console.log("Response from getRedemptions:", response.data);
    return response.data;
  },
  

  // requestRewardsRedemption: async (data, cancel = false) => { //Vishy 2025-02-23 this is renamed to "requestRedemption"
  // Claude: Buyer digital asset API methods 25-02-2026
  getBuyerAssets: async (buyerId, cancel = false) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `buyers/digital-assets/${buyerId}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  getMyAssets: async (cancel = false) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `buyers/digital-assets`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  addBuyerAsset: async (data, cancel = false) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `buyers/digital-assets`,
      method: "POST",
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  updateBuyerAsset: async (assetId, data) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `buyers/digital-assets/${assetId}`,
      method: "PATCH",
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  deleteBuyerAsset: async (assetId, cancel = false) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `buyers/digital-assets/${assetId}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  // Claude: fetch URL metadata for Add Asset modal — shared utils endpoint 01-04-2026
  fetchAssetInfo: async (url) => {
    const response = await api.request({
      url: "utils/fetch-url-info",
      method: "GET",
      params: { url },
    });
    return response.data.data;
  },

  requestRedemption: async (data, cancel = false) => {
    console.log("Redemption Requested")
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/rewards/sendRedemptionDetails`, //Vishy 2025-02-23 changed from sendRequest to sendRedemptionDetails
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },

  // Claude: all platform events for events dropdown — not buyer-specific 10-03-2026
  getAllEvents: async (cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "buyers/events/all",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  // Claude: Feeds — saved (starred) or browsed (read) paginated feed 14-03-2026
  getMyFeeds: async ({ page = 1, limit = 20, assetType, status = 'starred' } = {}) => {
    const { token } = store.getState().user;
    const params = { page, limit, status };
    if (assetType) params.assetType = assetType;
    const response = await api.request({ url: "buyers/feeds", method: "GET", params, headers: { Authorization: `Bearer ${token}` } });
    return responseHandler(response);
  },
  // Claude: Feeds unread — assets not yet acted on; optional seller filters 14-03-2026
  getUnreadFeeds: async ({ page = 1, limit = 20, assetType, targetCountry, targetIndustries, targetTags, verifiedOnly } = {}) => {
    const { token } = store.getState().user;
    const params = { page, limit };
    if (assetType) params.assetType = assetType;
    if (targetCountry?.length) params.targetCountry = targetCountry.join(',');
    if (targetIndustries?.length) params.targetIndustries = targetIndustries.join(',');
    if (targetTags?.length) params.targetTags = targetTags.join(',');
    if (verifiedOnly) params.verifiedOnly = 'true';
    const response = await api.request({ url: "buyers/feeds/unread", method: "GET", params, headers: { Authorization: `Bearer ${token}` } });
    return responseHandler(response);
  },
  // Claude: Feeds Skip→read, Save→starred 14-03-2026
  patchFeedStatus: async (sellerAssetId, status) => {
    const { token } = store.getState().user;
    const response = await api.request({ url: `buyers/feeds/${sellerAssetId}`, method: "PATCH", data: { status }, headers: { Authorization: `Bearer ${token}` } });
    return responseHandler(response);
  },
  addToFeeds: async (sellerAssetId) => {
    const { token } = store.getState().user;
    const response = await api.request({ url: "buyers/feeds", method: "POST", data: { sellerAssetId }, headers: { Authorization: `Bearer ${token}` } });
    return responseHandler(response);
  },
  removeFromFeeds: async (sellerAssetId) => {
    const { token } = store.getState().user;
    const response = await api.request({ url: `buyers/feeds/${sellerAssetId}`, method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
    return responseHandler(response);
  },

  // Claude: D3 — buyer saves a seller from RFX response screen 26-02-2026
  addSellerToList: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "buyers/sellers",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: buyer fetches own statement records for subscription tab 25-Apr-2026
  getStatements: async () => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "buyers/statements",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },
};

const cancelApiObject = defineCancelApiObject(BuyerAPI);
